import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=74715162&scoped=true"
import script from "./editArticle.vue?vue&type=script&lang=js"
export * from "./editArticle.vue?vue&type=script&lang=js"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=74715162&lang=less"
import style1 from "./editArticle.vue?vue&type=style&index=1&id=74715162&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74715162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74715162')) {
      api.createRecord('74715162', component.options)
    } else {
      api.reload('74715162', component.options)
    }
    module.hot.accept("./editArticle.vue?vue&type=template&id=74715162&scoped=true", function () {
      api.rerender('74715162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/articlemanagement/editArticle.vue"
export default component.exports